import { AuthType, getAccessTokenInfoFromCookie, getErrorAsString, isTokenExpired, refreshAccessToken } from '@notes/webintegrations-common'
import { isEdgeHubQueryParamPresent } from '../lib/urlParserUtils'
import { createGetUserInfo } from '../shared/auth/authLibFactories'
import { InitialTokenFetchActivity } from '../shared/auth/InitialTokenFetchActivity'
import { Log } from '../shared/logger/Log'
import { IUserFlowInformation } from './IUserFlowInformation'
import { redirectToAuth } from './redirectToAuth'

const O365_AUTH: AuthType = 'o365'

// Performs o365 auth flow:
// 1) Assuming the user has logged in and we've identified that the user is o365
// 2) Gets and returns IAuthenticatedUserInfo
// Note: We don't need to exchange tokens here as we do it on-demand
export async function o365AuthFlow(activity: InitialTokenFetchActivity): Promise<IUserFlowInformation> {
  let tokenInfo = getAccessTokenInfoFromCookie()
  if (!tokenInfo) {
    activity.finishWithFailure(O365_AUTH, 'MissingO365TokenInfo')
    return {
      shouldStopExecution: false,
      userInfo: undefined,
    }
  }

  if (isTokenExpired(tokenInfo.expires_in)) {
    try {
      await refreshAccessToken()
    } catch (error) {
      Log.logger.warn(`Error occurred while refreshing access token: ${getErrorAsString(error)}, redirect user to sign in.`)
      if (isEdgeHubQueryParamPresent()) {
        return redirectToAuth(false)
      }

      redirectToAuth(false)
    }
    tokenInfo = getAccessTokenInfoFromCookie()
  }
  if (!tokenInfo) {
    activity.finishWithFailure(O365_AUTH, 'MissingO365TokenInfoAfterRefresh')
    return {
      shouldStopExecution: false,
      userInfo: undefined,
    }
  }

  const userInfoGetter = createGetUserInfo(O365_AUTH)
  const userInfo = await userInfoGetter.getUserInfo(tokenInfo.access_token, O365_AUTH)

  // Token exchanges for O365 are done on-demand since they are not needed to get userInfo

  activity.finishWithSuccess(userInfo.authType, 'ObtainedUser')
  return {
    shouldStopExecution: false,
    userInfo: userInfo,
  }
}
